import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUserCog,
  faQuestion,
  faWifi,
  faBalanceScale,
  faEnvelope,
  faEnvelopeOpen,
  faLock,
} from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import './styles.css';

const TooltipIcon = ({
  type,
  appliedBy,
  appliedDate,
  lockedBy,
  lockedDate,
  content,
  contentStyle,
  iconStyle,
}) => {
  const [hover, setHover] = useState(false);

  const hoverOn = () => {
    setHover(true);
  };

  const hoverOff = () => {
    setHover(false);
  };

  let tooltip;

  const recruiter = {
    iconClassNames: 'tooltip-icon__icon tooltip-icon__icon--recruiter',
    content: 'Active Recruiter',
  };

  const noJobsNotifications = {
    iconClassNames: 'tooltip-icon__icon tooltip-icon__icon--no-notifications',
    content: 'Jobs or Projects notifications are turned off for this user',
  };

  const appliedToProcess = {
    iconClassNames: 'tooltip-icon__icon tooltip-icon__icon--applied',
    content: (
      <div>
        <div>Applied by: {appliedBy}</div>
        <div>Date: {appliedDate}</div>
      </div>
    ),
  };

  const online = {
    iconClassNames: 'tooltip-icon__icon tooltip-icon__icon--online',
    content: 'Online',
  };

  const locked = {
    iconClassNames: 'tooltip-icon__icon tooltip-icon__icon--locked',
    content: (
      <div>
        This Candidate was locked on {lockedDate} by {lockedBy || 'Admin'}
      </div>
    ),
  };

  const question = {
    iconClassNames: 'tooltip-icon__icon tooltip-icon__icon--question',
    content: <div>{content}</div>,
  };

  const doubt = {
    iconClassNames: 'tooltip-icon__icon tooltip-icon__icon--doubt',
    content: 'This Candidate has changed their mind',
  };

  const envelope = {
    iconClassNames: 'tooltip-icon__icon tooltip-icon__icon--envelope',
    content: "This Candidate has received Setup Email and didn't respond",
  };

  const envelopeOpen = {
    iconClassNames: 'tooltip-icon__icon tooltip-icon__icon--envelope-open',
    content: 'This Candidate has received Setup Email and responded',
  };

  switch (type) {
    case 'recruiter': {
      tooltip = { ...recruiter };
      break;
    }
    case 'no-notifications': {
      tooltip = { ...noJobsNotifications };
      break;
    }
    case 'applied': {
      tooltip = { ...appliedToProcess };
      break;
    }
    case 'online': {
      tooltip = { ...online };
      break;
    }
    case 'doubt': {
      tooltip = { ...doubt };
      break;
    }
    case 'envelope': {
      tooltip = { ...envelope };
      break;
    }
    case 'envelopeOpen': {
      tooltip = { ...envelopeOpen };
      break;
    }
    case 'locked': {
      tooltip = { ...locked };
      break;
    }
    default:
      tooltip = { ...question };
  }

  const fontawesomeIcon =
    type === 'no-notifications'
      ? faUserCog
      : type === 'online'
      ? faWifi
      : type === 'doubt'
      ? faBalanceScale
      : type === 'envelope'
      ? faEnvelope
      : type === 'envelopeOpen'
      ? faEnvelopeOpen
      : type === 'locked'
      ? faLock
      : faQuestion;

  const fontawesomeIconSize = type === 'no-notifications' ? '1x' : 'sm';

  return (
    <div
      className="tooltip-icon"
      onMouseEnter={hoverOn}
      onMouseLeave={hoverOff}
      onMouseOver={hoverOn}
      onMouseOut={hoverOff}
      onMouseUp={hoverOn}
      onMouseDown={hoverOff}
      onFocus={hoverOn}
      onBlur={hoverOff}
    >
      {type === 'no-notifications' ||
      type === 'question' ||
      type === 'online' ||
      type === 'doubt' ||
      type === 'envelope' ||
      type === 'envelopeOpen' ||
      type === 'locked' ? (
        <FontAwesomeIcon
          icon={fontawesomeIcon}
          size={fontawesomeIconSize}
          className={tooltip.iconClassNames}
          style={iconStyle}
        />
      ) : (
        <span style={iconStyle} className={tooltip.iconClassNames} />
      )}

      {hover && (
        <div className="tooltip-icon__tooltip" style={contentStyle}>
          <div className="tooltip-icon__tooltip-content">{tooltip.content}</div>
        </div>
      )}
    </div>
  );
};

TooltipIcon.propTypes = {
  type: PropTypes.oneOf([
    'online',
    'recruiter',
    'no-notifications',
    'applied',
    'question',
    'doubt',
    'envelope',
    'envelopeOpen',
    'locked',
  ]).isRequired,
  appliedBy: PropTypes.string,
  appliedDate: PropTypes.string,
  lockedBy: PropTypes.string,
  lockedDate: PropTypes.string,
  iconStyle: PropTypes.object,
};

export default TooltipIcon;
